export default __webpack_public_path__ + "static/media/origin_car3.b9d2f538.png";